// extracted by mini-css-extract-plugin
export default {"participantMenu":"ParticipantMenu_participantMenu__IC54W","participantOption":"ParticipantMenu_participantOption__Mp0Nl"};